import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const ExclamationSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg height="100px" width="100px" fill={color} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
        <g>
          <g>
            <path d="M50,20.38c-3.682,0-6.667,2.984-6.667,6.666v28.939c0,3.682,2.985,6.666,6.667,6.666c3.681,0,6.666-2.984,6.666-6.666    V27.046C56.667,23.364,53.682,20.38,50,20.38z" />
            <circle cx="50" cy="72.954" r="6.666" />
          </g>
        </g>
      </svg>
    </div>
  );
};

ExclamationSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default ExclamationSVG;
